<app-breadcrumb></app-breadcrumb>
<div class="card mb-0">
    <div class="card-body">
        <dtg-manage-schedule-drive-list [listType]="DtgListType.list"></dtg-manage-schedule-drive-list>
    </div>
</div>
